module.exports = __webpack_public_path__ + "49dedd237591b77cf783b35348da215d.jpg";